(() => {
  const elementName = 'ask-product-variation-groups';

  if (customElements.get(elementName)) return;

  class ProductVariationGroups extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-grouping-enabled')) return;

      this.abortController?.abort();
      this.abortController = new AbortController();

      // 初次加载只显示当前分组，不自动跳转。
      this.applyGroup(this.dataset.initialGroup || 'g1');

      this.addEventListener(
        'click',
        (event) => {
          if (!(event.target instanceof Element)) return;

          const button = event.target.closest('[data-display-group]');

          if (!button || button.closest(elementName) !== this) return;

          const group = button.dataset.displayGroup;
          if (!group) return;

          const items = this.getGroupItems(group);

          // 当前商品已属于目标分组，不重复跳转。
          if (group === this.dataset.initialGroup) {
            this.applyGroup(group);
            return;
          }

          // 按“全部关联商品”的排列寻找该组第一个商品链接。
          const targetLink = items
            .map((item) => item.querySelector('a[href]'))
            .find((link) => link);

          if (!targetLink) {
            this.applyGroup(group);
            return;
          }

          const targetUrl = new URL(targetLink.href, window.location.href);

          // 目标是当前商品时，仅更新分组显示。
          if (
            targetUrl.origin === window.location.origin &&
            targetUrl.pathname === window.location.pathname &&
            targetUrl.search === window.location.search
          ) {
            this.applyGroup(group);
            return;
          }

          window.location.assign(targetUrl.href);
        },
        { signal: this.abortController.signal }
      );
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    getGroupItems(group) {
      return Array.from(
        this.querySelectorAll('[data-variation-groups]')
      ).filter((item) => {
        const groups = item.dataset.variationGroups.trim().split(/\s+/);
        return groups.includes(group);
      });
    }

    applyGroup(group) {
      this.querySelectorAll('[data-variation-groups]').forEach((item) => {
        const groups = item.dataset.variationGroups.trim().split(/\s+/);
        item.hidden = !groups.includes(group);
      });

      this.querySelectorAll('[data-display-group]').forEach((button) => {
        button.setAttribute(
          'aria-pressed',
          String(button.dataset.displayGroup === group)
        );
      });
    }
  }

  customElements.define(elementName, ProductVariationGroups);
})();
